// extracted by mini-css-extract-plugin
export default {"actions":"EditStorageBalanceModal_actions__CCFf-","modalContent":"EditStorageBalanceModal_modalContent__cju-m"};